/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';

import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { SkeletonItem } from '../SkeletonItem';

const styles = cssMap({
	wrapper: {
		minWidth: '246px',
	},
	wrapperWithPadding: {
		minWidth: '246px',
		paddingTop: token('space.100'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.200'),
	},
});

export function LoadingMenu({ padded = false }: { padded?: boolean }) {
	return (
		<Box
			testId="global-create-content-loading-menu"
			xcss={padded ? styles.wrapperWithPadding : styles.wrapper}
		>
			{Array.from({ length: 6 }, (_, index) => (
				<SkeletonItem key={`loading-skeleton-item-${index}`} contentHeight={8} />
			))}
		</Box>
	);
}
